import { getStore } from '../store/store';
import type { ChatAnswer } from '../types';

export function getCopilotSearchAnswer(): ChatAnswer | undefined {
    return getStore().chatAnswer;
}

export function getIsLoading(): boolean {
    return getStore().isLoading;
}

export function getCurrentQuery(): string | undefined {
    return getStore().currentQuery;
}
